import { GreenSystemIcon } from "App/global-style";
import React from "react";

interface Props {
  included?: boolean | string;
}

export const IsIncludedCoverage = ({
  included,
}: Props): React.ReactElement | null => {
  if (typeof included === "string") {
    return <small>{included}</small>;
  }

  if (included === true) {
    return <GreenSystemIcon name="check" />;
  }

  return null;
};
